import { combineReducers } from "redux";
import appReducer from './app/appReducer';
import authReducer from './auth/authReducer';

const rootReducer = combineReducers({
    appReducer,
    authReducer
});

export default rootReducer;